<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.1968 14.1968L1.00008 1.00007" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        <path d="M14.1973 1L1.00056 14.1967" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
    </svg>
</template>